import { Component } from "@angular/core";
import { Platform, AlertController } from "@ionic/angular";
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { ScreenOrientation, OrientationType } from '@capawesome/capacitor-screen-orientation';

import { App } from '@capacitor/app';
import { AppLauncher } from '@capacitor/app-launcher';


import { NotyfService } from "./services/notyf/notyf.service";
import { EnvironmentService } from "./services/environment/environment.service";
import { ApiService } from "./services/api/api.service";
import { FcmService } from "./services/fcm/fcm.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { CartService } from "./services/cart/cart.service";
import { SettingsService } from "./services/settings/settings.service";
import { environment } from "src/environments/environment";
import { Browser } from '@capacitor/browser';
import { Capacitor } from "@capacitor/core";


@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  loading = true;
  currentPlatform: string = "";
  cart_timeout: any;
  app_version: string = environment.api.version;
  platform_type: string = 'web';

  constructor(
    private platform: Platform,
    private settings: SettingsService,
    private auth: AuthService,
    private fcmService: FcmService,
    private cartService: CartService,
    private api: ApiService,
    private alertController: AlertController,
    private notyf: NotyfService,
  ) { }

  ngOnInit() {
    this.initializeApp();
  }

  async initializeApp() {

    this.platform.ready().then(async () => {

      this.platform_type = await this.loadPlatform();     
      this.registerCartRefresh();

      if (this.currentPlatform !== "web") {
        
        try {
          await this.fcmService.checkAndSetupFCM();
        } catch (err) {
          console.error('FCM setup failed:', err);
        }

        this.configureStatusBar()

        if (this.platform.is('hybrid')) {
          await ScreenOrientation.lock({ type: OrientationType.PORTRAIT_PRIMARY });
        } else {
          console.log('ScreenOrientation plugin not available on web');
        }

        const info = await App.getInfo();
        this.app_version = info.version;
        await SplashScreen.hide();
        await this.checkVersion();
      }
      await this.checkVersion();
    });
  }

  // registerCartRefresh() {
  //   this.auth.loggedIn$.subscribe((isLoggedIn) => {
  //     if (isLoggedIn) {
  //       this.cartService.getCartExternal().catch(() => {
  //         this.auth.logout();
  //         this.notyf.error("You have been logged out.");
  //       });

  //       this.cart_timeout = setInterval(() => {
  //         this.cartService.getCartExternal().catch(() => {});
  //       }, 3600000); // 1 hour
  //     } else {
  //       clearInterval(this.cart_timeout);
  //     }
  //   });
  // }

  registerCartRefresh() {

    this.auth.loggedIn$.subscribe((isLoggedIn) => {
  
      if (isLoggedIn) {  
        this.cartService.validateCartOnce().catch(() => {
          this.auth.logout();
          this.notyf.error("You have been logged out.");
        });
  
        this.cart_timeout = setInterval(() => {
          this.cartService.validateCartOnce().catch(() => {});
        }, 3600000); // 1 hour
  
      } else {  
        clearInterval(this.cart_timeout);  
      }
  
    });
  
  }

  async checkVersion() {
    const response = await this.api.get("version-check", {
      version: this.app_version,
      venue_id: environment.api?.venue_id == null ? '' : environment.api?.venue_id,
      //platform: this.currentPlatform,
    }).toPromise();

    if(response["force_update"] == 'yes' || response["force_update"] == true){
      if (response["valid"] === false) {
        const alert = await this.alertController.create({
          header: "Update Available",
          backdropDismiss: false,
          message: "A newer version of this app is available. Please update to continue.",
          buttons: [
            {
              text: "Update",
              handler: () => {
                this.openAppStore(response["link"]);
                // this.notyf.error({
                //   message: `Link: ${response["link"]}`,
                //   duration: 5000,
                //   dismissible: true,
                // });
                return false;
              },
            },
          ],
        });
        await alert.present();
      }
    }    
  }

  async loadPlatform() {
    this.currentPlatform = await this.settings.getPlatform();
    return this.currentPlatform;
  }

  async openAppStore(appIdOrPackage: string) {
    let storeUrl = '';
  
    if (Capacitor.getPlatform() === 'android') {
      storeUrl = `https://play.google.com/store/apps/details?id=${appIdOrPackage}`;
    } else if (Capacitor.getPlatform() === 'ios') {
      storeUrl = `https://apps.apple.com/app/id${appIdOrPackage}`;
    } else {
      console.warn('Unsupported platform for app store link');
      return;
    }
  
    try {
      await Browser.open({ url: storeUrl });
    } catch (error) {
      console.error('Error opening app store URL:', error);
      this.notyf.error('An error occurred while opening the app store link.');
    }
  }

  async configureStatusBar() {
    if (Capacitor.isNativePlatform()) {
      if (Capacitor.getPlatform() === 'android') {        
        await EdgeToEdge.enable();
        await StatusBar.setBackgroundColor({ color: environment.settings.app.default_statusBar_color });
        await StatusBar.setStyle({ style: Style.Light });
      } else {
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: environment.settings.app.default_statusBar_color });
        await StatusBar.setOverlaysWebView({overlay:false})
        await StatusBar.show();
      }
    }
  }

 
}
